function fuzzyTokenScore(text, token) {
  const hay = String(text || '').toLowerCase()
  const needle = String(token || '').toLowerCase().trim()
  if (!needle) return 1
  if (!hay) return 0
  if (hay === needle) return 200
  if (hay.startsWith(needle)) return 160
  const idx = hay.indexOf(needle)
  if (idx >= 0) return 140 - Math.min(idx, 40)

  let qi = 0
  let score = 0
  let prevMatch = false
  for (let i = 0; i < hay.length && qi < needle.length; i += 1) {
    if (hay[i] === needle[qi]) {
      score += prevMatch ? 12 : 18
      if (i === 0 || hay[i - 1] === ' ' || hay[i - 1] === '@' || hay[i - 1] === '.') {
        score += 8
      }
      qi += 1
      prevMatch = true
    } else {
      prevMatch = false
    }
  }
  return qi === needle.length ? score : 0
}

export function fuzzyScoreItem(item, query, fields) {
  const tokens = String(query || '').toLowerCase().trim().split(/\s+/).filter(Boolean)
  if (!tokens.length) return 1

  let total = 0
  for (const token of tokens) {
    const best = Math.max(
      0,
      ...fields.map((field) => fuzzyTokenScore(item[field], token))
    )
    if (!best) return 0
    total += best
  }
  return total
}

export function rankByFuzzySearch(items, query, { fields, getRecency = null } = {}) {
  const trimmed = String(query || '').trim()
  if (!trimmed) return items

  return items
    .map((item) => ({
      item,
      score: fuzzyScoreItem(item, trimmed, fields),
      recency: getRecency ? getRecency(item) : 0,
    }))
    .filter((row) => row.score > 0)
    .sort((a, b) => {
      if (b.score !== a.score) return b.score - a.score
      if (b.recency !== a.recency) return b.recency - a.recency
      return String(a.item.name || '').localeCompare(String(b.item.name || ''))
    })
    .map((row) => row.item)
}
